import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import KanbanUI from '../kanban/KanbanUI';
import ListHeader from '../list/ListHeader';
import MassUpdatePopup from '../list/MassUpdatePopup';
import MassEmailPopup from '../list/MassEmailPopup';
import MassSmsPopup from '../list/MassSmsPopup';
import MassWhatsAppPopup from '../list/MassWhatsAppPopup';
import TableUI from '../list/TableUI';
import HeaderViewList from '../list/HeaderViewList';
import FilterPannel from '../filter/FilterPannel';

import CallPopup from '../call/CallPopup';
import MeetingPopup from '../meeting/MeetingPopup';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import Display from '../../util/Display';
import KanbanAPI from '../../api/KanbanAPI';
import LeadAPI from '../../api/LeadAPI';
import KeyValueAPI from '../../api/KeyValueAPI';
import ImportExportAPI from '../../api/ImportExportAPI';
import ViewController from '../../controller/ViewController';
import KanbanController from '../../controller/KanbanController';
import DB from '../../util/LocalDB';

import './LeadAddEdit.css';

class LeadList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Lead);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.lead ? cView.lead : 0));
    if (!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.kanbanViews = KanbanController.getViews(Const.Lead);
    this.moduleView = reactLocalStorage.get(Const.View)
      ? reactLocalStorage.get(Const.View)
      : reactLocalStorage.set(Const.View, Const.ListView);
    let currentKanbanView = Object.keys(reactLocalStorage.getObject(Const.CurrentKanbanView)).length ? reactLocalStorage.getObject(Const.CurrentKanbanView) : null;
    // check if currentKanbanView exists in list of kanbanViews
    const currentValidKanbanView = this.kanbanViews.find(item => item.id === currentKanbanView?.value);
    if(!currentValidKanbanView) {
      // Old one gets updated or deleted
      reactLocalStorage.remove(Const.CurrentKanbanView)
      currentKanbanView = null;
    }

    this.actions = DB.getActions(Const.Lead);
    this.setList(filters);
    this.data = { leads: [], leadCount: 0 };
    this.state = {
      massUpdate: false, massEmail: false, massSMS: false, massWhatsApp: false,
      inApiCall: true, isFilterOpen: false, popup: '', 
      view: this.moduleView === Const.KanbanView ? Const.VIEW_OPTIONS[1] : Const.VIEW_OPTIONS[0], 
      selectedKanbanView: currentKanbanView, 
    };
    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    this.selected = [];
  }

  componentDidMount() {
    if (this.List) {
      const cView = reactLocalStorage.getObject(Const.CurrentViews);
      const views = ViewController.getViews(Const.Lead);
      const view = views.find(view => view.id === cView.lead);
      this.onTabClick(view ? view.id : this.views[0].id);

      // restore last selected kanban view (local cache only)
      // const cached = reactLocalStorage.getObject(Const.CurrentKanbanView);
      // if (cached?.id && this.kanbanViews[cached.id]) {
      //   this.setState({ selectedKanbanView: views[cached.id] });
      // }

      // KanbanAPI.list((res) => {
      //   const views = {};
      //   res.forEach(v => {
      //     views[v.group_by] = {
      //       label: v.name,
      //       value: v.group_by,
      //       id: v.id
      //     };
      //   });

      //   this.setState({ kanbanViews: views });

      // }, this.onFail);
    }
  }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.lead;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, lead: lists };
    }

    const fields = ["firstname", "enquiry_date", "phone", "email", "address~street", "address~city", "source",
      "responsible_person"];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, lead: [...modelfields.lead, this.list] };
    }
    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : {};
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'enquiry_date';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1;

    if (this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ? this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (!field) {
        return false;
      }

      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  };

  saveListFilters = filters => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.filters = filters;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  saveListFields = fields => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.fields = fields;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePerPage = perPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.pagination.perPage = perPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  savePageChange = currentPage => {
    const tmpField = reactLocalStorage.getObject(Const.FieldList);
    const tmp = tmpField.lead.find((item) => item.view === this.view.id);
    tmp.pagination.currentPage = currentPage;
    reactLocalStorage.setObject(Const.FieldList, tmpField);
  };

  loadLeads = () => {
    /**
     * * Add below in future and made some changes to update `state.view`
     * * when kanban view changes to list view
     * * if need to minimze api calls, when switching forth and back kanban view
     */
    // if(this.state.view.value !== Const.ListView) return; 

    reactLocalStorage.setObject(Const.ListLead, this.list);
    const mainFilters = ViewController.getRestrictionsView(Const.Lead);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true, popup: '' });
    LeadAPI.list({ ...this.list, filters }, this.onReceived, this.onFail);
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = res => {
    this.data.leads = res.data;
    this.data.leadCount = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.savePageChange(currentPage);
    this.loadLeads();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.savePerPage(perPage);
    this.loadLeads();
  };

  onFieldSelection = fields => {
    if (fields.includes('phone') && this.HideAllPhone) {
      fields = fields.splice(this.list.fields.indexOf('phone'), 1);
    }
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadLeads();
  };

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    this.saveListSort(this.list.sorting);
    this.loadLeads();
  };

  showMassUpdate = () => {
    if (this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please apply filters or Select Data', 'danger');
    } else this.setState({ ...this.state, massUpdate: !this.state.massUpdate });
  };
  showMassEmail = () => this.setState({ ...this.state, massEmail: !this.state.massEmail });
  showMassSMS = () => this.setState({ ...this.state, massSMS: !this.state.massSMS });
  showMassWhatsApp = () => this.setState({ ...this.state, massWhatsApp: !this.state.massWhatsApp });

  showMassDelete = () => {
    if (this.list.filters.length === 0 && this.selected.length === 0) {
      Util.showNotification('Failure', 'Please select leads', 'danger');
    } else {
      Util.confirmAlert('Delete', `Are you sure you want to mass delete (${this.selected.length}) leads ?`,
        'Mass Delete', 'No', () => {
          this.setState({ ...this.state, inApiCall: true });
          LeadAPI.massDelete(this.list, this.selected, this.onMassDeleted, this.onFail);
        });
    }
  };
  onMassDeleted = () => {
    Util.showNotification('Successful', 'Lead Mass Deleted successfull.', 'success');
    this.selected = [];
    this.loadLeads();
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListLead, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };

  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => {
    this.list.pagination.currentPage = 1;
    this.list.filters = filters;
    this.savePageChange(this.list.pagination.currentPage);
    this.saveListFilters(filters);
    this.loadLeads();
  };

  onAddEdit = indx => this.props.navigate(`${this.props.match.path}/add-edit/`
    + `${indx !== -1 ? this.data.leads[indx].id : 0}`);
  onPreview = indx => {
    let gIndx = (this.list.pagination.currentPage - 1) * this.list.pagination.perPage;
    gIndx = gIndx + indx + 1;
    this.props.navigate(`${this.props.match.path}/preview/`
      + `${this.data.leads[indx].id}?indx=${gIndx}&size=${this.data.leadCount}`);
  };
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.leads[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      LeadAPI.delete(this.data.leads[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Lead deleted successfully', 'success');
    this.loadLeads();
  };

  onProperties = indx => {
    const lead = this.data.leads[indx];
    const filter = [];

    if (lead.min_budget && lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'in', value: `${lead.min_budget}~${lead.max_budget}`
    });
    else if (lead.min_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'start-with', value: `${lead.min_budget}~`
    });
    else if (lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'end-with', value: `~${lead.max_budget}`
    });

    if (lead.property_transaction) filter.push({
      field: 'property_transaction', type: 'select',
      condition: 'in', value: `${lead.property_transaction}`
    });

    if (lead.property_is) filter.push({
      field: 'property_is', type: 'select',
      condition: 'in', value: `${lead.property_is}`
    });

    if (lead.property_type) filter.push({
      field: 'property_type', type: 'select',
      condition: 'in', value: `${lead.property_type}`
    });
    if (lead.area) filter.push({
      field: 'area', type: 'select',
      condition: 'in', value: `${lead.area}`
    });

    this.props.navigate(`/property?filters=${JSON.stringify(filter)}`);
  };

  onCallClick = indx => {
    this.leadId = this.data.leads[indx].id;
    this.setState({ ...this.state, popup: LeadConst.Call });
  };

  onMeetingClick = indx => {
    this.leadId = this.data.leads[indx].id;
    this.setState({ ...this.state, popup: LeadConst.Meeting });
  };

  import = () => this.props.navigate(`/setting/import/add?model=${Const.Lead}`);
  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    + ` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      const filters = ViewController.filters([...this.list.filters], this.view.filters, this.Restrict);
      ImportExportAPI.exportModel(Const.Lead, filters, this.list.sorting, this.data.leadCount, fields, this.model.model_no,
        this.onExport, this.onFail);
    });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Lead Exported in progress.'
      + ' Please visit Settings', 'success');
  };

  onMassUpdate = updates => {
    this.setState({ ...this.state, massUpdate: false, inApiCall: true });
    LeadAPI.massUpdate(this.list, this.selected, updates, this.onMassUpdated, this.onFail);
  };
  onMassUpdated = () => {
    Util.showNotification('Successful', 'Lead Mass Updated successfull.', 'success');
    this.selected = [];
    this.setState({ ...this.state, selected: !this.state.selected });
    this.loadLeads();
  };

  onMassEmail = (temp, config) => {
    this.setState({ ...this.state, massEmail: false, inApiCall: true });
    LeadAPI.massEmail(this.list, temp, config, this.onMassEmailSent, this.onFail);
  };
  onMassEmailSent = () => {
    Util.showNotification('Successful', 'Lead Mass Updated successfull.', 'success');
    this.selected = [];
    this.setState({ ...this.state, selected: !this.state.selected });
    this.loadLeads();
  };

  onMassSMS = (temp, config) => {
    this.setState({ ...this.state, massSMS: false, inApiCall: true });
    const mainFilters = ViewController.getRestrictionsView(Const.Lead);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    LeadAPI.massSMS(filters, temp, config, this.onMassSmsSent, this.onFail);
  };
  onMassSmsSent = () => {
    Util.showNotification('Successful', 'Lead Mass Updated successfull.', 'success');
    this.selected = [];
    this.setState({ ...this.state, selected: !this.state.selected });
    this.loadLeads();
  };

  onSelect = id => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = id => {
    this.selected = this.selected.filter(item => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = () => {
    for (let i = 0; i < this.data.leads.length; i++) {
      const id = this.selected.find(item => item === this.data.leads[i].id);
      if (!id) this.selected.push(this.data.leads[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemoveAll = () => {
    for (let i = 0; i < this.data.leads.length; i++) {
      this.selected = this.selected.filter(item => item !== this.data.leads[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };

  onTabClick = (view) => {
    this.setState({ ...this.state, isFilterOpen: false, inApiCall: true });
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.lead = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    this.view = this.views.find((item) => item.id === view);
    this.setList();
    this.loadLeads();
  };

  onKanbanCreate = (payload) => {
    return
    KanbanAPI.save({
      name: payload.label,
      group_by: payload.value,
      module_id: Const.Lead
    }, (res) => {
      const newView = { ...payload, id: res.id };
      this.setState(prev => ({
        kanbanViews: { ...prev.kanbanViews, [res.id]: newView },
        selectedKanbanView: newView
      }));  
      Util.showNotification('Successful', 'Kanban created successfully.', 'success');
    });

  };
  onKanbanChange = (kanbanView) => this.setState({ selectedKanbanView: kanbanView });
  onModuleViewChange = (moduleView) => {
    this.setState({ view: moduleView });
    // Check if there is already selected kanban view or not
    if(this.kanbanViews.length && !this.state.selectedKanbanView) {
      // By default select the first one
      const newView = this.kanbanViews[0];
      reactLocalStorage.setObject(Const.CurrentKanbanView, { label: newView?.name, value: newView?.id, field_key: newView?.group_by });
      this.onKanbanChange({ label: newView?.name, value: newView?.id, field_key: newView?.group_by });
    }
  }

  render() {
    const isListView = this.state.view.value === Const.ListView;
    const renderTableView = () => {
      if (!this.List) return null;
      const fields = [...new Set(this.list.fields)];
      return this.state.view.value === Const.ListView 
        ? <TableUI
            data={this.data.leads}
            model={this.model}
            fields={fields}
            order={this.list.sorting}
            pagination={this.list.pagination}
            inApiCall={this.state.inApiCall}
            preview={true}
            update={this.Update}
            delete={this.Delete}
            onAddEdit={this.onAddEdit}
            onPreview={this.onPreview}
            onDelete={this.onDelete}
            onFieldSelection={this.onFieldSelection}
            onOrderChange={this.onOrderChange}
            isFilterOpen={this.state.isFilterOpen}
            findProperties={this.onProperties}
            selected={this.selected} onSelect={this.onSelect} onRemove={this.onRemove}
            onSelectAll={this.onSelectAll} onRemoveAll={this.onRemoveAll}
            onCallClick={this.onCallClick} onMeetingClick={this.onMeetingClick}
            actions={this.actions} />
        : <KanbanUI
            model={this.model}
            match={this.props.match}
            list={this.list}
            restrict={this.Restrict}
            view={this.view}
            kanbanViews={this.kanbanViews}
            selectedKanbanView={this.state.selectedKanbanView} />
    }

    return (
      <div>
        {this.state.massUpdate ?
          <MassUpdatePopup showMassUpdate={this.showMassUpdate} models={this.model}
            onMassUpdate={this.onMassUpdate} />
          : null
        }
        <CallPopup show={this.state.popup === LeadConst.Call} onHide={() => this.setState({ ...this.state, popup: '' })}
          reload={this.loadLeads} model_no={Const.Lead} model_id={this.leadId} />
        <MeetingPopup show={this.state.popup === LeadConst.Meeting} onHide={() => this.setState({ ...this.state, popup: '' })}
          reload={this.loadLeads} model_no={Const.Lead} model_id={this.leadId} />
        <MassEmailPopup show={this.state.massEmail} onHide={this.showMassEmail}
          filters={this.list.filters} model_no={Const.Lead} />

        <MassSmsPopup
          show={this.state.massSMS}
          onHide={this.showMassSMS}
          listFilters={this.list.filters}
          viewFilters={this.view.filters}
          restrict={this.Restrict}
          model_no={Const.Lead}
        />

        <MassWhatsAppPopup
          show={this.state.massWhatsApp}
          onHide={this.showMassWhatsApp}
          listFilters={this.list.filters}
          viewFilters={this.view.filters}
          restrict={this.Restrict}
          model_no={Const.Lead}
        />
        {isListView && (
        <HeaderViewList views={this.views} view={this.view} onTabClick={this.onTabClick} />
         )}

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.leadCount}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
          update={this.update}
          showMassUpdate={this.showMassUpdate}
          showMassDelete={this.showMassDelete}
          showMassEmail={this.showMassEmail}
          showMassSMS={this.showMassSMS}
          showMassWhatsApp={this.showMassWhatsApp}
          view={this.state.view}
          kanbanViews={this.kanbanViews}
          selectedKanbanView={this.state.selectedKanbanView}
          onKanbanViewsCreate={this.onKanbanCreate}
          onKanbanViewChange={this.onKanbanChange}
          onModuleViewChange={this.onModuleViewChange}
        />

        <div className="container-fluid">
          <div className="row">
            {renderTableView()}

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              view={this.view}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadList);
